<template lang="pug">
.input-wrapper
  label(v-show="label" :for="label") {{ label }}
  ckeditor(
    :editor="editor"
    :config="editorConfig"
    v-bind="$attrs"
    v-model="innerText"
    )
</template>

<script>
import CKEditor from '@ckeditor/ckeditor5-vue'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'

export default {
  name: 'RomatchTextarea',
  components: { ckeditor: CKEditor.component },
  props: {
    label: String,
    value: String,
  },
  data() {
    return {
      innerText: null,
      editor: ClassicEditor,
      editorConfig: {
        toolbar: [
          'heading',
          '|',
          'bold',
          'italic',
          '|',
          'NumberedList',
          'BulletedList',
          '|',
          'undo',
          'redo',
        ],
      },
    }
  },
  methods: {
    setInnerText(value) {
      if (value) {
        if (value.startsWith('<p>')) this.innerText = value
        else this.innerText = `<p>${value}</p>`
      } else this.innerText = null
    },
  },
  created() {
    this.setInnerText(this.value)
  },
  watch: {
    innerText(newVal) {
      this.$emit('input', newVal)
    },
    value(newVal) {
      this.setInnerText(newVal)
    },
  },
}
</script>

<style scoped lang="stylus">
@import '~@/assets/_forms.styl'

.input-wrapper
  input-wrapper()
</style>
